export const NAV_LIST = "wk-nav";
export const NAV_ITEM = "wk-nav-item";
export const NAVBAR_DROPDOWN_ITEM = "wk-navbar-dropdown-item";

export const ACTIVE_CLASS = "wk-active";
export const VISIBLE_CLASS = "wk-visible";

export const NAVBAR_DROPDOWN_LIST = "wk-dropdown-list";
export const NAVBAR_DROPDOWN_LABEL = "wk-navbar-dropdown-label";
